export default __webpack_public_path__ + "keyboard.png";